import { useSearchParams } from 'react-router-dom';

import { SEARCH_PARAM_LOCK_PIN, SEARCH_PARAM_LOCK_PIN_TYPE } from '@/utils/constants/queries';

type PinnedItem = {
  pinnedItemId: string | null;
  pinnedItemType: string | null;
};

const usePinnedItem = (): PinnedItem => {
  const [searchParams] = useSearchParams();

  const pinnedItemId = searchParams.get(SEARCH_PARAM_LOCK_PIN);
  const pinnedItemType = searchParams.get(SEARCH_PARAM_LOCK_PIN_TYPE);

  return { pinnedItemId, pinnedItemType };
};

export default usePinnedItem;
